export default __webpack_public_path__ + "static/media/blog-list.e105eea4.png";